import { render, staticRenderFns } from "./ContractAddAttachmentsFormDialog.vue?vue&type=template&id=07ace72c&"
import script from "./ContractAddAttachmentsFormDialog.vue?vue&type=script&lang=ts&"
export * from "./ContractAddAttachmentsFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports